import React from 'react'
import classNames from 'classnames'

// evertel
import { Col, Icon, Media } from '@evertel/web/ui'
import { DocumentTile } from '@evertel/web/document'
import { ReplyTileBodyProps } from './ReplyTileBody'
import { parsedContent } from '../../../../utils/message'


interface ReplyTileBodyUserProps extends ReplyTileBodyProps {
    variant?: 'forward' | 'user'
}

const ReplyTileBodyUser: React.FC<ReplyTileBodyUserProps> = ({
    message,
    media,
    variant
}) => {

    const truncatedMessage = message.text.length > 250 ? message.text.slice(0, 250) + '...' : message.text

    const size = variant === 'forward' ? 40 : 50
    const padding = variant === 'forward' ? 5 : 15

    const isDocumentEventMessage = message.type === 'event' &&
        ['document_added', 'document_updated'].includes(message.meta?.eventType)
    const documentId = (message.meta as { documentId?: number })?.documentId

    return (
        <Col className="mt-1">
            <div style={{ display: 'flex', alignItems: 'center' }}>
                {message.isUrgent && (
                    <span className="urgent-icon">
                        <Icon
                            name="triangle-exclamation"
                        />
                    </span>
                )}

                <div
                    dangerouslySetInnerHTML={{ __html: parsedContent(truncatedMessage) }}
                    className={classNames('reply-body', {'urgent': message.isUrgent})}
                    style={{ display: 'inline-block' }}
                />
            </div>
            {isDocumentEventMessage && documentId && (
                <DocumentTile
                    documentId={documentId}
                    className="document-tile-reply mt-2"
                />
            )}
            {!!media?.length && (
                <div className="reply-body-media-container">
                    {media.map(m => {
                        return (
                            <Media
                                key={m.id}
                                media={m}
                                width={size}
                                height={size}
                                rounded
                                allowDownload={false}
                                className="reply-body-media-element"
                                videoProps={{ asThumbnail: true }}
                                imageProps={{ flexibility: 'fixed' }}
                                fileProps={{width: size, height: size, padding}}
                                resizeMode="cover"
                                variant="preview"
                            />
                        )})}
                </div>
            )}
        </Col>
    )
}

export { ReplyTileBodyUser }
